import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const PageHeader = ({ title, breadcrumbs = [] }) => {
  const lastIndex = breadcrumbs.length - 1;

  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">{title}</h4>

          {breadcrumbs.length > 0 && (
            <div className="page-title-right">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb m-0">
                  {breadcrumbs.map((item, index) => (
                    <li
                      key={index}
                      className={`breadcrumb-item ${
                        index === lastIndex ? 'active' : ''
                      } aria-current="page"`}
                    >
                      {index === lastIndex || !item.link ? (
                        item.label
                      ) : (
                        <Link to={item.link}>{item.label}</Link>
                      )}
                    </li>
                  ))}
                </ol>
              </nav>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      link: PropTypes.string, // optional
    })
  ),
};

export default PageHeader;